import { render, staticRenderFns } from "./itemmanage.vue?vue&type=template&id=2188ab12&scoped=true&"
import script from "./itemmanage.vue?vue&type=script&lang=js&"
export * from "./itemmanage.vue?vue&type=script&lang=js&"
import style0 from "./itemmanage.vue?vue&type=style&index=0&id=2188ab12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188ab12",
  null
  
)

export default component.exports